interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= total; i += 1) pages.push(i);

  const btnBase =
    'min-w-9 h-9 px-3 rounded-md text-sm flex items-center justify-center transition-colors cursor-pointer';

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap">
      <button
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line"></i>
      </button>

      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          className={
            p === current
              ? `${btnBase} bg-primary-500 text-background-50 font-medium`
              : `${btnBase} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700`
          }
        >
          {p}
        </button>
      ))}

      <button
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-right-s-line"></i>
      </button>

      <span className="ml-2 text-xs md:text-sm text-foreground-500">
        第 {current} / {total} 页
      </span>
    </div>
  );
}